import {get} from 'lodash';
import {useEffect, useMemo} from 'react';
import {useRecoilValueLoadable} from 'recoil';
import {useEventBus} from '../../../../../hooks/useEventBus';
import {LoadableHelpers} from '../../../../../shared/helpers/loadableHelpers';
import {dashboardRequestsQuery} from '../../../../../store/reports/selectors';
import {useRequestMapStore} from '../store/useRequestMapStore';
import {usePrimaryChartsDataStore} from '../store/usePrimaryChartsDataStore';

export const useRequestDataGate = () => {
  const bus = useEventBus();
  const contractId = useRequestMapStore((s) => s.selectedContractId);
  const dashboard = usePrimaryChartsDataStore((s) => s.contracts);

  const contractIds = useMemo(() => {
    const result: number[] = [];
    const contract = dashboard.contracts?.find((c) => c.contract?.id === contractId);
    const serviceRequests = contract?.serviceRequests || [];
    serviceRequests.forEach((sr) => sr.srId && result.push(sr.srId));
    return result;
  }, [dashboard, contractId]);

  const setIsLoading = useRequestMapStore((s) => s.setIsLoading);
  const setRequests = useRequestMapStore((s) => s.setRequests);
  const data = useRecoilValueLoadable(dashboardRequestsQuery({contractIds}));

  useEffect(() => {
    LoadableHelpers.handle(data, {
      success: (content) => setRequests(content),
      loading: () => setIsLoading(true),
      error: (key, payload) => {
        setIsLoading(false);
        bus?.emit(key, payload);
      },
    });
  }, [bus, data, setIsLoading, setRequests]);
};
